module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAASVJREFUeNpiYBhpgBFDxH92ApBUAOIPQLyAYWPqB9pb7D/7PJA0QBK5AMSOtLCcCc2nBmjyIH4CLXzMhMRWwKHGn9YW4wrOC7S2eAEWS0COmUgLi5nhrJubfzBo+K0EsjiA+AcQbwDiRGDCejBM87H/bAEsqRoSx7Ds5D8bJC+AJv8AHCr+sxWgOcAeKZoOgkMOS6ghW+wAJPdjsRiUjw9A1YDkHdDkG6F0PR4PNgLNaMCVuMgF8QQshTjKf3YAtS1WIFJdP7UtJt6BkDRCVYtB+T8QGI+MYBp3oeNAbYtBlm4AsyB0IQ51AtS0+AJGdoHlAiKLTHIBrjL+AK0tpriSGLV41OJRiykCLCgVOqJuZUATh4GF0ModlzwDAbUHGEYsAAgwAC3oSW5MRlD9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/linkedin-footer.png
// module id = 001H
// module chunks = 0